// @flow
import React, { Component } from 'react'
import StyledDropdownTreeSelect from 'components/ui/StyledDropdownTreeSelect'
import { t } from 'ttag'
import { SHOW_FILTER_SEARCH_LIMIT } from 'store/constants/constants'

class CustomDropDownTreeSelect extends Component<{
  data: Array,
  onChange: () => void,
  texts: Object,
  maxHeight: string,
  hideIcon: boolean,
  hideDropDown: boolean
}> {
  constructor(props) {
    super(props)
    this.selectRef = React.createRef()
  }

  componentDidUpdate() {
    const selectComponent = this.selectRef.current
    selectComponent.onInputChange(selectComponent.searchInput.value)
  }

  onInputKeyDown = () => {
    const selectComponent = this.selectRef.current
    selectComponent.node.lastElementChild.lastElementChild.scrollTop = 0
  }

  handleOnFocus = () => {
    const selectComponent = this.selectRef.current
    selectComponent.searchInput.addEventListener('keydown', this.onInputKeyDown)
  }

  handleOnBlur = () => {
    const selectComponent = this.selectRef.current
    selectComponent.searchInput.removeEventListener('keydown', this.onInputKeyDown)
  }

  render() {
    const { data, onChange, texts, maxHeight, hideIcon, hideDropDown } = this.props
    const showDropdown = !hideDropDown ? { showDropdown: 'initial' } : null
    return (
      <StyledDropdownTreeSelect
        ref={this.selectRef}
        data={data}
        texts={
          texts || {
            placeholder: t`Start typing to search`,
            noMatches: t`No results found`,
            label: t`Search`
          }
        }
        showPartiallySelected
        {...showDropdown}
        onChange={onChange}
        maxHeight={maxHeight}
        searchable={data.length >= SHOW_FILTER_SEARCH_LIMIT}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
        hideIcon={hideIcon}
      />
    )
  }
}

export default CustomDropDownTreeSelect
